import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import Button from '../../components/button/index';
import { Cross, Download, Warning, Tick } from '../../helpers/icon-dictionary';
import messages from './messages';
import ConfirmationMessage from '../../components/confirmation-message/index';
import Modal from '../../components/modal/index';
import TeacherUnassign from '../../components/teacher-unassign/index';

const AssignedTeacherList = ({
    handleOnTeacherUnassign,
    teachers,
    intl,
    handleOnUnassignConfirm,
    teachersOperationSuccessConfirmation,
    isUserOperationModalOpen,
    isLoading,
    showModal,
    handleOnCloseModal,
    handleOnPrintTeacherSignInCard,
    downloadingTeachersIds }) => {
    const confirmation = isUserOperationModalOpen
        ? (
            <TeacherUnassign
                handleOnCancel={handleOnCloseModal}
                handleOnOk={handleOnUnassignConfirm}
                icon={Warning}
                isLoading={isLoading}
                title={intl.formatMessage(messages.unassignTeachers)}>
                <div>{intl.formatMessage(messages.selectedTeachersWillBe)} <span
                    className={css.highlight}>{intl.formatMessage(messages.unassigned)}</span> {intl.formatMessage(messages.loseAccessToProducts)}.
                </div>
            </TeacherUnassign>)
        : (
            <ConfirmationMessage
                handleOnCloseModal={teachersOperationSuccessConfirmation}
                icon={Tick}
                title={intl.formatMessage(messages.teachersUnassigned)} />);
    return (<div className={css.teacherList}>
        <div className={css.header}>{intl.formatMessage(messages.teachers)}</div>
        <div>{
            map(teachers, teacher => (
                <div className={css.list} key={teacher.userProfileId}>
                    <div className={css.listItem}>{ teacher.name }</div>
                    <Button
                        containerClassName={css.downloadSignInCards}
                        handleOnClick={() => handleOnPrintTeacherSignInCard(teacher.userProfileId)}
                        icon={Download}
                        iconClassName={css.icon}
                        label={intl.formatMessage(messages.downloadCards)}
                        loading={downloadingTeachersIds.has(teacher.userProfileId)}
                        loadingLabel={intl.formatMessage(messages.downloading)} />
                    <Button
                        containerClassName={css.unassign}
                        handleOnClick={() => handleOnTeacherUnassign(teacher.userProfileId)}
                        icon={Cross}
                        iconClassName={css.icon} />
                </div>
            ))
        }</div>
        <Modal show={showModal}>
            { confirmation }
        </Modal>
    </div>);
};

AssignedTeacherList.propTypes = {
    handleOnTeacherUnassign: PropTypes.func,
    teachers: PropTypes.array,
    intl: intlShape.isRequired,
    teachersOperationSuccessConfirmation: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    showModal: PropTypes.bool,
    isUserOperationModalOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    handleOnPrintTeacherSignInCard: PropTypes.func,
    downloadingTeachersIds: PropTypes.object
};

export default injectIntl(styleable(css)(AssignedTeacherList));



// WEBPACK FOOTER //
// ./app/components/assigned-teacher-list/index.js